import {createMetaManager} from "vue-meta"

export default createMetaManager()
